import { useEffect } from 'react';

import { createGlobalStyle } from 'styled-components';

const PREVENT_FOCUS_CLASS = 'disable-focus-styles';

/**
 * Contains global styling to remove :focus outlines
 */
export const FocusToggleStyles = createGlobalStyle`
  body.${PREVENT_FOCUS_CLASS} *:focus {
    outline: none;
  }
  
  /* Hack for SelectionIndicator */ 
  body.${PREVENT_FOCUS_CLASS} *::after {
    outline: none !important;
  }
`;

/**
 * Toggles whether or not `:focus` styling is enabled on the webpage.
 *
 * To use this hook, you must include the `FocusToggleStyles` component.
 */
export const useFocusToggle = (allowFocus: boolean = true, rootElementSelector = 'body') => {
  useEffect(() => {
    if (allowFocus) {
      document.querySelectorAll(rootElementSelector).forEach(element => {
        element.classList.remove(PREVENT_FOCUS_CLASS);
      });
    } else {
      document.querySelectorAll(rootElementSelector).forEach(element => {
        element.classList.add(PREVENT_FOCUS_CLASS);
      });
    }
  }, [allowFocus, rootElementSelector]);

  return { FocusToggleStyles };
};
